module.exports = __webpack_public_path__ + "static/media/img-placeholder.270bea0b.svg";